(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const videoItems = document.querySelectorAll('.featured-video-item');
    if (!videoItems.length) return;
    
    videoItems.forEach(function(videoItem) {
      const videoElement = videoItem.querySelector('video');
      const soundControl = videoItem.querySelector('.sound-control');
      
      if (!videoElement || !soundControl) return;
      
      // Toggle sound on click
      soundControl.addEventListener('click', function() {
        if (videoElement.muted) {
          videoElement.muted = false;
          soundControl.classList.remove('is-muted');
        } else {
          videoElement.muted = true;
          soundControl.classList.add('is-muted');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
